import * as CryptoJS from 'crypto-js';

export class CommonEncrypt {

    /**
     * 取得MD5加密的值 
     * @param toEncryptStr  待加密字符串 
     * @param macKey        后台返回的随机字符串 
     */
    public static getHmacMD5Code(toEncryptStr: string, macKey: string) {
        let hashCode: string = null;
        hashCode = CryptoJS.HmacMD5(toEncryptStr, macKey).toString(CryptoJS.enc.Hex);
        return hashCode;
    }

    /**
     * key 十六位十六进制数作为密钥
     * iv 十六位十六进制数作为密钥偏移量
	 * [encrypt 加密]
	 * @param passwordNum mima
	 */
    public static encryptPassword(passwordNum: string) {
        const key = CryptoJS.enc.Utf8.parse("FYLJKJYXGShealth");
        const iv = CryptoJS.enc.Utf8.parse('healthFYLJKJYXGS');
        let srcs = CryptoJS.enc.Utf8.parse(passwordNum);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.ciphertext.toString().toUpperCase();
    }

    /**
    * [decrypt 解密]
    * @param passwordNum mima
    */
    public static decryptPassword(passwordNum: string) {
        const key = CryptoJS.enc.Utf8.parse("FYLJKJYXGShealth");
        const iv = CryptoJS.enc.Utf8.parse('healthFYLJKJYXGS');
        let encryptedHexStr = CryptoJS.enc.Hex.parse(passwordNum);
        let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    }


    // /**
    //  * 加密数据
    //  * @param data     数据字符串  
    //  * @param macKey   后台返回的随机字符串 
    //  */
    // public static encryptData(data: string, macKey: string) {
    //     if (data == "" || data == null ) {
    //         return "";
    //     }
    //     let key: any = CryptoJS.enc.Latin1.parse(macKey);
    //     var iv = CryptoJS.enc.Latin1.parse("0179571910024734");
    //     return CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding }).toString();
    // }

    // /**
    //  * 解密数据 
    //  * @param data     数据字符串  
    //  * @param macKey   后台返回的随机字符串 
    //  */
    // public static decryptData(data: string, macKey: string) {
    //     try{
    //         if (data == "" || data == null ) {
    //             return "";
    //         }
    //         let key: any  = CryptoJS.enc.Latin1.parse(macKey);
    //         var iv   = CryptoJS.enc.Latin1.parse("0179571910024734");
    //         return CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(data,key,{iv:iv,mode:CryptoJS.mode.CBC,padding:CryptoJS.pad.ZeroPadding})).toString();
    //     }catch(err){
    //         return ""+err;	
    //     }
    // }

    
    /**
     * 加密数据
     * @param data     数据字符串  
     * @param macKey   后台返回的随机字符串 
     */
    public static encryptData(data: string, macKey: string) {
        if (data == "" || data == null ) {
            return "";
        }
        var key = CryptoJS.enc.Utf8.parse(macKey);// 秘钥
        var iv = CryptoJS.enc.Utf8.parse("0179571910024734");//向量iv
        var encrypted = CryptoJS.AES.encrypt(data, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
        return encrypted.toString();
    }

    /**
     * 解密数据 
     * @param data     数据字符串  
     * @param macKey   后台返回的随机字符串 
     */
    public static decryptData(data: string, macKey: string) {
        try{
            if (data == "" || data == null ) {
                return "";
            }
            var key = CryptoJS.enc.Utf8.parse(macKey);
            var iv = CryptoJS.enc.Utf8.parse("0179571910024734");
            var decrypted = CryptoJS.AES.decrypt(data, key, {iv: iv, padding: CryptoJS.pad.Pkcs7});
            return CryptoJS.enc.Utf8.stringify(decrypted);
        }catch(err){
            return ""+err;	
        }
    }
}